import { deleteMailMessage, moveMailMessage } from "@/lib/api/mailActions";
import type { MailDeletePayload, MailMovePayload } from "@/lib/types/compose";
import type { ApiResult } from "@/lib/api/client";
import type { MailDeleteResponse, MailMoveResponse } from "@/lib/types/compose";

export const MAIL_MUTATION_TIMEOUT_MS = 120_000;
export const MAIL_MUTATION_DELETE_CHUNK = 8;
const MUTATION_TIMEOUT_RETRY_DELAY_MS = 4_000;

async function withTimeoutRetry<T>(
  call: (timeoutMs: number) => Promise<ApiResult<T>>
): Promise<ApiResult<T>> {
  let res = await call(MAIL_MUTATION_TIMEOUT_MS);
  if (!res.ok && res.status === 0) {
    await new Promise((resolve) => window.setTimeout(resolve, MUTATION_TIMEOUT_RETRY_DELAY_MS));
    res = await call(MAIL_MUTATION_TIMEOUT_MS);
  }
  return res;
}

export function isMutationTimeout(res: { ok: boolean; status: number }): boolean {
  return !res.ok && res.status === 0;
}

export function deleteMailMessageResilient(payload: MailDeletePayload) {
  return withTimeoutRetry((timeoutMs) => deleteMailMessage(payload, { timeoutMs }));
}

export function moveMailMessageResilient(payload: MailMovePayload) {
  return withTimeoutRetry((timeoutMs) => moveMailMessage(payload, { timeoutMs }));
}

export type MailDeleteResult = ApiResult<MailDeleteResponse>;
export type MailMoveResult = ApiResult<MailMoveResponse>;
